<div>
  <!--
  <agm-map *ngIf="map !== undefined" [latitude]="map.lat" [longitude]="map.lng" [zoom]="map.zoom"
    [zoomControl]="map.zoomControl" [disableDefaultUI]="false" (mapClick)="mapClicked($event)">

    <ng-container *ngIf="map.markers !== undefined">
      <agm-marker *ngFor="let m of map.markers; let i = index" (markerClick)="clickedMarker(m.label, i)"
        [latitude]="m.lat" [longitude]="m.lng" [label]="m.label || ''" [markerDraggable]="m.draggable || false"
        (dragEnd)="markerDragEnd(m, $event)">

        <agm-info-window>
          <strong>InfoWindow content</strong>
        </agm-info-window>

      </agm-marker>
    </ng-container>

    <agm-circle *ngIf="map.circle !== undefined" [latitude]="map.circle.lat" [longitude]="map.circle.lng"
      [radius]="map.circle.radius" [fillColor]="map.circle.fillColor" [circleDraggable]="map.circle.circleDraggable"
      [editable]="map.circle.editable">
    </agm-circle>

  </agm-map>
  -->
</div>
